import {Component} from '@angular/core';

@Component({
    selector: 'tfl-sender-account-icon',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
                <path d="M0 24h24V0H0z"/>
                <path fill="#212121" d="M23.001 21.017V23H1v-1.983h22.001zM22 10.109v1.983h-1v5.95h1v1.983H2v-1.983h1v-5.95H2v-1.983H0V8.573L12 1l12 7.573v1.536h-2zm0-.447L12 3.35 2 9.662v.447h4v1.983H5v5.95h3v-5.95H7v-1.983h4v1.983h-1v5.95h1v-2.975h2v2.975h1v-5.95h-1v-1.983h4v1.983h-1v5.95h3v-5.95h-1v-1.983h4v-.447z"/>
            </g>
        </svg>
    `
})
export class SenderAccountIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/sender.account.icon.ts